export const SET_SHOP_INFO     = 'SET_SHOP_INFO';
export const SET_USER_INFO     = 'SET_USER_INFO';
export const SET_CHECKOUT_INFO = 'SET_CHECKOUT_INFO';
export const SET_CART       = 'SET_CART';